import React, { useState } from 'react';

import {
  Button,
  Dialog as DialogUI,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
  MenuItem,
} from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

function Dialog({ title, description, confirm, cancel, callback, text }) {
  const [open, setOpen] = useState(false);

  async function handleSubmit() {
    await setOpen(false);
    await callback();
  }

  return (
    <>
      {!text ? (
        <IconButton size="small">
          <Tooltip title={t('s.geral.botaoexcluir')}>
            <Delete onClick={() => setOpen(true)} />
          </Tooltip>
        </IconButton>
      ) : (
        <MenuItem onClick={() => setOpen(true)}>{text}</MenuItem>
      )}

      <DialogUI
        open={open}
        disableBackdropClick
        disableEscapeKeyDown
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            {cancel}
          </Button>
          <Button onClick={() => handleSubmit()} color="primary" autoFocus>
            {confirm}
          </Button>
        </DialogActions>
      </DialogUI>
    </>
  );
}

Dialog.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  confirm: PropTypes.string,
  cancel: PropTypes.string,
  callback: PropTypes.func.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

Dialog.defaultProps = {
  title: 'Continuar exclusão?',
  description: 'Está ação não poderá mais ser desfeita.',
  confirm: 'Sim, continuar!',
  cancel: 'Cancelar',
  text: false,
};

export default Dialog;
